import classNames from "classnames";
import Image, { StaticImageData } from "next/legacy/image";
import Container from "www/shared/components/container/Container";

const MiniFeaturesSection = ({
  headerText,
  linkId,
  subtitleText,
  miniFeatures,
}: {
  headerText: string;
  subtitleText: string;
  linkId: string;
  miniFeatures: {
    title: string;
    description: string;
    image: StaticImageData;
  }[];
}) => {
  const numRows = miniFeatures.length / 3;
  return (
    <section
      id={linkId}
      className="lg:h-screen flex flex-col items-center justify-center py-16 lg:py-28"
    >
      <Container>
        <div className="max-w-4xl flex flex-col items-center text-center mx-auto">
          <h2 className="text-gray-900 text-3xl sm:text-4xl lg:text-5xl font-semibold">
            {headerText}
          </h2>
          <p className="text-gray-600 text-lg mt-3 md:mt-5">{subtitleText}</p>
        </div>
        <div
          className={classNames(
            `grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 mt-8 md:mt-12 lg:mt-20`,
            numRows === 1 ? "grid-rows-1" : "grid-rows-2"
          )}
        >
          {miniFeatures.map((accelerator) => (
            <div
              className="border border-gray-200 rounded-2xl flex flex-col p-4 md:p-6 md:pb-4"
              key={accelerator.title}
            >
              <div className="bg-blueGray-100 rounded-lg w-9 h-9 flex items-center justify-center">
                <Image src={accelerator.image} alt="" width={20} height={20} />
              </div>
              <h4 className="text-gray-800 text-base lg:text-lg font-semibold mt-4 md:mt-6">
                {accelerator.title}
              </h4>
              <p className="text-gray-600 text-sm mt-2">
                {accelerator.description}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default MiniFeaturesSection;
